import { jsx as t, jsxs as F } from "react/jsx-runtime";
import { clsx as k } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useRef as T, useState as x, useEffect as E } from "react";
import { usePrefersReducedMotion as G } from "../../utils/use-prefers-reduced-motion.js";
import { RocheUIIcon as H } from "../icon/roche-icon.js";
import { RocheUILanguageSwitch as J } from "../language-switch/roche-language-switch.js";
import { RocheUILanguageSwitchLayoutType as K } from "../language-switch/roche-language-switch.types.js";
import { RocheUIMobileNavigationBlock as M } from "../mobile-navigation-block/roche-mobile-navigation-block.js";
import n from "./roche-mobile-navigation.module.scss.js";
import { findActivePath as Q, pathToId as V, splitPath as U, parentOf as g, removeBranch as y } from "./roche-mobile-navigation-helpers.js";
const te = ({
  primaryNav: a,
  secondaryNav: f,
  closeNavLabel: A,
  currentPage: i,
  isNavOpen: r,
  setIsNavOpen: h,
  languageSwitchConfig: l
}) => {
  var R;
  const b = T(null), m = T(null), [p, u] = x(!1), [_, v] = x(/* @__PURE__ */ new Set()), L = G();
  E(() => {
    const o = Q(a ?? [], i);
    o && v(() => {
      const s = /* @__PURE__ */ new Set();
      for (let c = 1; c <= o.length; c++)
        s.add(V(o.slice(0, c)));
      return s;
    });
  }, [i, a]), E(() => {
    var o;
    const e = m.current;
    if (e) {
      if (r) {
        e.showModal(), (o = b.current) == null || o.focus();
        return;
      }
      if (L) {
        e.close();
        return;
      }
      e.open && u(!0);
    }
  }, [r, L]);
  const $ = () => {
    h(!1);
  }, B = (e) => {
    var o;
    e.target === m.current && p && e.propertyName === "transform" && (u(!1), (o = m.current) == null || o.close());
  }, I = (e) => {
    v((o) => {
      const s = new Set(o), c = U(e).length, P = g(e);
      for (const d of Array.from(s)) {
        const q = U(d).length === c, z = P === g(d);
        q && z && d !== e && y(s, d);
      }
      return s.has(e) ? y(s, e) : s.add(e), s;
    });
  }, j = k(
    n["mobile-navigation__overlay"],
    r && n["mobile-navigation__overlay--open"],
    p && n["mobile-navigation__overlay--closing"]
  ), D = ((R = (l == null ? void 0 : l.alternates) ?? []) == null ? void 0 : R.length) > 0;
  return /* @__PURE__ */ t("nav", { className: n["mobile-navigation"], children: /* @__PURE__ */ F(
    "dialog",
    {
      className: j,
      onClose: () => h(!1),
      id: "mobile-navigation",
      ref: m,
      inert: r ? null : "",
      onTransitionEnd: B,
      children: [
        /* @__PURE__ */ t("header", { className: n["mobile-navigation__header"], children: /* @__PURE__ */ t(
          "button",
          {
            className: n["mobile-navigation__close-button"],
            onClick: $,
            ref: b,
            "aria-label": A,
            "aria-controls": "mobile-navigation",
            type: "button",
            children: /* @__PURE__ */ t(H, { icon: "mobile-close", height: "32px", decorative: !0 })
          }
        ) }),
        /* @__PURE__ */ t("ul", { className: k(n["mobile-navigation__list"], n["mobile-navigation__list--primary"]), children: a == null ? void 0 : a.map((e, o) => /* @__PURE__ */ t(
          M,
          {
            id: `${o}`,
            link: e,
            depth: 1,
            expanded: _,
            onToggle: I,
            isNavOpen: r,
            currentPage: i
          },
          `p-${o}`
        )) }),
        /* @__PURE__ */ t("ul", { className: n["mobile-navigation__list"], children: f == null ? void 0 : f.map((e, o) => /* @__PURE__ */ t(
          M,
          {
            id: `s-${o}`,
            link: e,
            depth: 1,
            expanded: _,
            onToggle: I,
            isNavOpen: r,
            currentPage: i
          },
          `s-${o}`
        )) }),
        l && D && /* @__PURE__ */ t("div", { className: n["mobile-navigation__meta-nav"], children: /* @__PURE__ */ t(
          J,
          {
            alternates: l.alternates,
            currentLocale: l.currentLocale,
            currentPage: i,
            translatedLocale: l.translations.translatedLocale,
            translatedAriaLabel: l.translations.translatedAriaLabel,
            layout: K.INLINE_LIST,
            onClick: l.handleClickTracking
          }
        ) })
      ]
    }
  ) });
};
export {
  te as RocheUIMobileNavigation
};
